import { Avatar, Input, ListItem, ListItemAvatar, Stack, Checkbox, FormControlLabel } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect } from "react";
import { useState } from "react";
import { DebugBox } from "@northpowerdev/np-react-utils";

/**
 * Editable form for account details: accountId, name, email, phone, notificationSettings
 * @param {accountDetails:{*}, accountChanged:Function}  
 * @returns 
 */
export function EditAccountForm({accountDetails, accountChanged}) {

    const [account, setAccount] = useState({
        ...accountDetails,
        notificationSettings: {
            recvEmailOnNewInspection: accountDetails?.notificationSettings?.recvEmailOnNewInspection || false,
            ...accountDetails?.notificationSettings
        }
    }) // {name, email, phone, accountId, notificationSettings}

    useEffect(() => {
        if (accountChanged && typeof(accountChanged) === 'function') {
          accountChanged({...account})
        }
    // (linter is worried about onUserChange but it's an output function)
    // eslint-disable-next-line 
    }, [account])

    const handleNameChange = (event) => {
      const updatedUser = {...account, name: event.target.value}
      setAccount(updatedUser)
    }

    const handleEmailChange = (event) => {
      const updatedUser = {...account, email: event.target.value}
      setAccount(updatedUser)
    }

    const handlePhoneChange = (event) => {
      const updatedUser = {...account, phone: event.target.value}
      setAccount(updatedUser)
    }

    const handleAccountIdChange = (event) => {
      const updatedUser = {...account, accountId: event.target.value}
      setAccount(updatedUser)
    }

    const handleEmailNotificationChange = (event) => {
      const updatedUser = {
        ...account, 
        notificationSettings: {
          ...account.notificationSettings,
          recvEmailOnNewInspection: event.target.checked
        }
      }
      setAccount(updatedUser)
    }

    return (
        <Box>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Avatar alt="Edit User" />
                </ListItemAvatar>
                <Stack direction="column">
                  <Input value={account.name} type="text" placeholder="Name" onChange={handleNameChange} sx={{width: '310px', fontSize: '1.25em', mb: 1}}/>
                  <Input value={account.email} type="email" placeholder="Email" onChange={handleEmailChange} sx={{width: '310px', mb: 1}} />
                  <Input value={account.phone} type="text" placeholder="Phone" onChange={handlePhoneChange} sx={{width: '310px', mb: 1}} />
                  <Input value={account.accountId} type="text" placeholder="Account Id" onChange={handleAccountIdChange} sx={{width: '310px', mb: 1}} />
                  <FormControlLabel
                    control={
                      <Checkbox 
                        checked={account.notificationSettings?.recvEmailOnNewInspection || false}
                        onChange={handleEmailNotificationChange}
                      />
                    }
                    label="Email on new Inspection"
                    sx={{width: '310px', mb: 1}}
                  />
                </Stack>
            </ListItem>
            <DebugBox title="account" stringify>{account}</DebugBox>
        </Box>
    )
}
